
    // 不用顶层 await：构建目标是 chrome87/safari14，顶层 await 在这些目标上不可用（esbuild 直接报错）。
    Promise.resolve(window.__langBootWait).then(function () { return import('./main.ts'); });
